"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AitoClient = void 0;
const axios_1 = __importDefault(require("axios"));
const lodash_1 = __importDefault(require("lodash"));
class AitoClient {
    constructor(settings, client) {
        this.settings = settings;
        this.client = client;
    }
    static createClient(params) {
        const { hostname, key } = params;
        const baseURL = this.getBaseUrl(hostname).toString();
        return new AitoClient({
            hostname,
            key,
            baseURL,
        }, axios_1.default.create({
            baseURL,
            headers: {
                'x-api-key': key,
            },
        }));
    }
    static createApigwBypassClient(params) {
        const { proxyHostname, hostname, key } = params;
        const aitoBaseURL = this.getBaseUrl(hostname);
        const proxyURL = this.getBaseUrl(proxyHostname, 'http').toString();
        const aitoHostHeader = aitoBaseURL.hostname;
        const arc = {
            baseURL: proxyURL,
            headers: {
                'x-amzn-remapped-host': aitoHostHeader,
                'x-api-key': key,
            },
        };
        console.log(`Creating AitoClient with proxy-settings: ${JSON.stringify(arc)}`);
        return new AitoClient({ proxyURL, baseURL: aitoBaseURL.toString(), key, hostname }, axios_1.default.create(arc));
    }
    static getBaseUrl(hostname, protocol = 'https') {
        return new URL(`${protocol}://${hostname}/api/v1`);
    }
    async getSchema(table) {
        const { data } = await this.client.get(`/schema${table ? '/' + encodeURIComponent(table) : ''}`);
        return data;
    }
    async createTable(table, schema) {
        await this.client.put(`/schema/${table}`, schema);
    }
    async truncateTable(table) {
        const { data } = await this.client.post('/data/_delete', {
            from: table,
            where: {},
        });
        return data.total;
    }
    async deleteTableSchema(table) {
        await this.client.delete(`/schema/${table}`);
    }
    async dropDatabase() {
        const { schema } = await this.getSchema();
        const retries = 10;
        const tables = Object.keys(schema);
        for (const table of tables) {
            for (let i = 0; i < retries; i++) {
                try {
                    await this.truncateTable(table);
                    break;
                }
                catch (e) { }
            }
        }
        await this.client.delete('/schema');
        const { schema: schemaNow } = await this.getSchema();
        if (!lodash_1.default.isEmpty(schemaNow)) {
            throw new Error('Database deletion failed');
        }
    }
    predict(predictQuery) {
        return this.client.post(`/_predict`, predictQuery);
    }
    search(searchQuery) {
        return this.client.post(`/_search`, searchQuery);
    }
    async analyze(sample, analyzer) {
        const response = await this.client.post(`/schema/_analyze`, {
            sample,
            analyzer,
        });
        return response.data;
    }
    async evaluateJob(evaluate) {
        const response = await this.client.post(`/jobs/_evaluate`, evaluate);
        return response.data;
    }
    async jobStatus(jobId) {
        const response = await this.client.get(`/jobs/${jobId}`);
        return response.data;
    }
    async jobResult(jobId) {
        const result = await this.client.get(`/jobs/${jobId}/result`);
        if (result.status === 202) {
            return undefined;
        }
        else if (result.status === 200) {
            return result.data;
        }
        else {
            throw new Error();
        }
    }
}
exports.AitoClient = AitoClient;
//# sourceMappingURL=AitoClient.js.map